<template>
  <el-dialog
    title="Linked Services"
    top="5vh"
    visible
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>Services</h1>
    <p>The following table listed linked services with this rate surcharge</p>
    <el-table
      v-loading="isLoading"
      :data="linkedServices"
      stripe
    >
      <el-table-column
        label="Service Name"
        prop="carrier_service"
        :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-' "
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteLinkedService(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[5, 10, 20, 50]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <hr>
    <h1>Attach Service</h1>
    <p>Attach service with this rate surcharge</p>
    <el-form
      ref="serviceForm"
      v-loading="isSaving"
      :rules="rules"
      :model="service"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Services"
            prop="carrier_service"
          >
            <el-select
              v-model="service.carrier_service"
              filterable
              placeholder="Search Service"
              value-key="id"
              :loading="isLoadingServices"
              class="w-100"
            >
              <el-option
                v-for="s in services"
                :key="s.id"
                :label="s.name"
                :value="s"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="attachService"
      >
        Attach
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    surcharge: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      linkedServices: [],
      service: {},
      services: [],
      isLoadingServices: false,
      isFullscreen: false,
      page: 1,
      perPage: 5,
      total: 0,
      isLoading: false,
      isSaving: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        carrier_service: [
          { required: true, message: 'Service is required', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.loadTable()
    this.loadLists()
    this.service = new this.$sdk.ratesurcharge_service()
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.ratesurcharge_service.list(builder => {
        builder.filters = { rate_surcharge_service_rate_surcharge: this.surcharge.id }
        builder.include = ['carrier_service']
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'name:asc'
      })
        .then(res => {
          this.linkedServices = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    loadLists () {
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.surcharge.carrier.id }
      }).then(res => { this.services = res })
        .finally(() => { this.isLoadingServices = false })
    },
    attachService () {
      this.$refs.serviceForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.service.rate_surcharge = this.surcharge
          this.$sdk.ratesurcharge_service.create(this.service, builder => {
            builder.include = ['carrier_service']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.service = new this.$sdk.ratesurcharge_service()
              this.$refs.serviceForm.resetFields()
              this.loadTable()
            })
        }
      })
    },
    deleteLinkedService (index, row) {
      this.$confirm('Are you sure to delete this?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete()
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
